import React from 'react';
import { Drawer, FloatButton, Space } from 'antd';
import { faFilter, faSearch, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import ButtonIcon from './ButtonComp';
import useClose from '../hooks/useClose';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonProps } from 'react-bootstrap';

interface IDrawerComp {
    title: string;
    children: React.ReactNode;
    placement?: 'left' | 'right' | 'top' | 'bottom';
    width?: number;
    onSearch?: () => void;
    type?: 'button' | 'floatButton';
    icon?: IconDefinition;
    variant?: ButtonProps['variant'];
}

const DrawerComp: React.FC<IDrawerComp> = ({
    title,
    children,
    placement = 'right',
    width = 400,
    onSearch,
    type = 'floatButton',
    icon = faFilter,
    variant = 'primary'
}) => {
    const { onClose, onOpen, isOpen } = useClose();

    return (
        <>
            {
                type === 'floatButton' ?
                    <FloatButton
                        icon={<FontAwesomeIcon icon={icon} />}
                        tooltip={"Desplegar los filtros de búsqueda"}
                        onClick={onOpen}
                        type='primary'
                    /> : <ButtonIcon
                        icon={icon}
                        tooltip={"Desplegar los filtros de búsqueda"}
                        onClick={onOpen}
                        variant={variant}
                    />
            }
            <Drawer
                title={title}
                placement={placement}
                width={width}
                onClose={onClose}
                open={isOpen}
                extra={
                    <Space>
                        {
                            onSearch &&
                            <ButtonIcon name={"Buscar"} icon={faSearch} variant='outline-success' onClick={onSearch} />
                        }
                    </Space>
                }
            >
                {children}
            </Drawer>
        </>
    );
};

export default DrawerComp;